module.exports = __webpack_public_path__ + "img/Logo branca.6a92715f.png";